'use client';

import { usePathname, useRouter } from 'next/navigation';
import { PropsWithChildren, useEffect, useState } from 'react';
import { Box, LoadingIndicator } from '@wishket/design-system';

import { ClientAuth } from '@/shared/auth';
import { PATH } from '@/shared/constants';

const AuthGuard = ({ children }: PropsWithChildren) => {
  const router = useRouter();
  const pathname = usePathname();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const validAuth = async () => {
      try {
        const accessToken = await ClientAuth.getAccessToken();

        if (!accessToken) {
          router.push(`${PATH.AUTH_LOGIN}?next=${pathname}`);
        }
      } catch (error) {
        router.push(`${PATH.AUTH_LOGIN}?next=${pathname}`);
      } finally {
        setIsLoading(false);
      }
    };

    validAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <Box className="flex h-screen items-center justify-center">
        <LoadingIndicator />
      </Box>
    );
  }

  return <>{children}</>;
};

export default AuthGuard;
